export const RepositoryListColumnNames = {
  name: 'Name',
  visibility: 'Visibility',
  size: 'Size',
  lastModified: 'Last Modified',
};

export const RobotAccountColumnNames = {
  robotAccountName: 'Robot account name',
  teams: 'Teams',
  repositories: 'Repositories',
  created: 'Created',
  lastAccessed: 'Last accessed',
};
